import React from "react";
import { DollarSign, TrendingUp } from "lucide-react";
import StyledTooltip from "../../common/StyledTooltip";

const shimmerKeyframes = `@keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}`;
const SkeletonBox = ({ w, h, style = {} }) => (
  <div style={{
    width: w, height: h, borderRadius: "6px",
    background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
    backgroundSize: "600px 100%",
    animation: "shimmer 1.4s infinite linear",
    ...style,
  }} />
);

export default function IncomeBreakdownCards({ data, loading = false }) {
  const isLarge = window.innerWidth > 1800;
  const incomeCards = [
    { title: "Principal Amount", amount: data?.financialBreakdown?.principal?.display || "₹0", originalValue: data?.financialBreakdown?.principal?.amount || 0, percent: data?.financialBreakdown?.principal?.percentage + "%" || "0%", color: "#155DFC", bg: "#ffffff" },
    { title: "Interest Income", amount: data?.financialBreakdown?.interest?.display || "₹0", originalValue: data?.financialBreakdown?.interest?.amount || 0, percent: data?.financialBreakdown?.interest?.percentage + "%" || "0%", color: "#00A63E", bg: "#ffffff" },
    { title: "Processing Fee Income", amount: data?.financialBreakdown?.processingFee?.display || "₹0", originalValue: data?.financialBreakdown?.processingFee?.amount || 0, percent: data?.financialBreakdown?.processingFee?.percentage + "%" || "0%", color: "#9810FA", bg: "#ffffff" },
    { title: "Other Charges", amount: data?.financialBreakdown?.charges?.display || "₹0", originalValue: data?.financialBreakdown?.charges?.amount || 0, percent: data?.financialBreakdown?.charges?.percentage + "%" || "0%", color: "#F59E0B", bg: "#ffffff" },
  ];

  return (
    <>
      <style>{shimmerKeyframes}</style>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: isLarge ? "30px" : "20px" }}>
        {(loading ? [1, 2, 3, 4] : incomeCards).map((card, index) => (
          <div key={index} style={{
            background: "#FFFFFF", borderRadius: "10px", padding: "18px",
            border: "0.8px solid #E5E7EB",
            boxShadow: "0px 1px 1px rgba(0,0,0,0.08), 0px 1px 2px rgba(0,0,0,0.06)",
            display: "flex", flexDirection: "column", gap: "10px", marginTop: "20px",
          }}>
            {loading ? (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <SkeletonBox w="48px" h="48px" style={{ borderRadius: "10px" }} />
                  <SkeletonBox w="24px" h="24px" style={{ borderRadius: "4px" }} />
                </div>
                <SkeletonBox w="100%" h="14px" style={{ marginTop: "8px" }} />
                <SkeletonBox w="80px" h={isLarge ? "28px" : "20px"} style={{ borderRadius: "4px" }} />
                <SkeletonBox w="60px" h="14px" />
              </>
            ) : (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ background: card.bg, color: card.color, width: "48px", height: "48px", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", fontWeight: "bold" }}>
                    <DollarSign color={card.color} />
                  </div>
                  <span style={{ color: card.color }}><TrendingUp /></span>
                </div>
                <h6 style={{ fontSize: isLarge ? "16px" : "14px", color: "#4A5565", margin: "8px 0px 0px 0px", fontWeight: "400" }}>{card?.title}</h6>
                <StyledTooltip value={card.originalValue}>
                  <h6 style={{ fontSize: isLarge ? "26px" : "16px", fontWeight: "700", color: card.color, margin: "0" }}>{card.amount}</h6>
                </StyledTooltip>
                <h6 style={{ fontSize: isLarge ? "16px" : "14px", color: "#64748b", fontWeight: "400", marginBottom: "0px" }}>{card.percent}</h6>
              </>
            )}
          </div>
        ))}
      </div>
    </>
  );
}